// TODO: a dirty fix as I have no fkng idea how to make it work with the svelte-i18n

export enum ErrorCode {
	USED_CODE = 'USED_CODE', //1
	EXPIRED_CODE = 'EXPIRED_CODE', //3
	NOT_BEFORE = 'NOT_BEFORE', //3
	NOT_AFTER = 'NOT_AFTER', //3
	NOT_EXISTING = 'NOT_EXISTING', //2
	INVALID_INPUT_CODE = 'INVALID_INPUT_CODE', //2
	INVALID_CODE = 'INVALID_CODE', //2
	ALREADY_HAS_COUPON = 'ALREADY_HAS_COUPON', //3
	MAX_NUMBER_OF_COUPONS_REACHED = 'MAX_NUMBER_OF_COUPONS_REACHED',
}
export interface ErrorScreen {
	screen: number;
	image: string;
	title: string;
	description: string;
	span: string;
	hideRetry?: boolean;
}

// to-do -> some of the text include the voucher code which I don;t have at the moment, can be included later
